


















































import _ from 'lodash';
import {
  recognition, onSubscribedToAccount, onUnsubscribedFromAccount,
  offSubscribedToAccount, offUnsubscribedFromAccount,
} from 'mycorems-app-accounts';
import RouterLink from '@/routing/RouterLink.vue';
import { HasTaskMixin } from '@/mixins';
import eventBus from '@/messaging/event-bus';
import { ClientAdded, EmailCampaignsFetched } from '@/messaging/events';
import { Client, ClientSummary, QPagination } from '@/types';
import Tooltip from '@/components/Tooltip.vue';
import repository from './agency-repository';

interface Data {
  clientSummaries: ClientSummary[],
  pagination: QPagination,
  columns: object[],
  orderBy: string,
  orderType: 'asc'|'desc',
}

export default HasTaskMixin.extend({
  props: {
    agencyId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      clientSummaries: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      columns: [
        {
          name: 'name',
          align: 'left',
          label: 'Account Name',
          orderBy: 'name',
        },
        {
          name: 'lastCampaignDate',
          align: 'left',
          label: 'Last Campaign Sent',
        },
        {
          name: 'campaignsSent',
          align: 'center',
          label: 'Campaigns Sent',
          orderBy: 'campaignsSent',
        },
        {
          name: 'recipients',
          align: 'center',
          label: 'Recipients',
          orderBy: 'recipients',
        },
        {
          name: 'avgOpenRate',
          align: 'center',
          label: 'Avg. Open Rate',
          orderBy: 'avgOpenRate',
        },
        {
          name: 'avgClickRate',
          align: 'center',
          label: 'Avg. Click Rate',
          orderBy: 'avgClickRate',
        },
        {
          name: 'avgBounceRate',
          align: 'center',
          label: 'Avg. Bounce Rate',
          orderBy: 'avgBounceRate',
        },
        {
          name: 'avgUnsubscribeRate',
          align: 'center',
          label: 'Avg. Unsubscribe Rate',
          orderBy: 'avgUnsubscribeRate',
        },
        {
          name: 'avgSpamRate',
          align: 'center',
          label: 'Avg. Spam Rate',
          orderBy: 'avgSpamRate',
        },
      ],
      orderBy: 'name',
      orderType: 'asc',
    };
  },
  watch: {
    agencyId(): void {
      this.load();
    },
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    filteredClientSummaries(): ClientSummary[] {
      return _
        .orderBy(this.clientSummaries, this.orderBy, this.orderType)
        .slice(
          (this.pagination.page - 1) * this.pagination.rowsPerPage,
          this.pagination.page * this.pagination.rowsPerPage,
        );
    },
    oppositeOrderType(): 'asc'|'desc' {
      return (this.orderType === 'asc') ? 'desc' : 'asc';
    },
    orderIcon(): string {
      return (this.orderType === 'asc') ? 'fas fa-sort-amount-down-alt' : 'fas fa-sort-amount-up';
    },
    orderTitle(): string {
      return (this.orderType === 'asc') ? 'Ascending' : 'Descending';
    },
    userId(): string|null {
      return recognition.getUserId();
    },
  },
  methods: {
    add(clientSummary: ClientSummary): void {
      this.clientSummaries.unshift(clientSummary);
    },
    onClientAdded(client: Client): void {
      const clientSummary: ClientSummary = this.buildFromClient(client);
      this.add(clientSummary);
    },
    buildFromClient(client: Client): ClientSummary {
      return {
        id: client.id,
        name: client.name,
        firstCampaignDate: null,
        lastCampaignDate: null,
        campaignsSent: 0,
        recipients: 0,
        avgClickRate: 0,
        avgOpenRate: 0,
        avgSpamRate: 0,
        avgBounceRate: 0,
        avgUnsubscribeRate: 0,
      };
    },
    getOrderIcon(order: string): string {
      if (this.orderBy === order) {
        return this.orderIcon;
      }
      return 'fas fa-sort-amount-down-alt';
    },
    order(field: string) {
      if (this.orderBy === field) {
        this.orderType = this.oppositeOrderType;
      }
      this.orderBy = field;
    },
    load(): void {
      if (!this.userId) return;
      this.task = repository.findSummary(this.agencyId, {
        userId: this.userId,
        startDate: null,
        endDate: null,
      });
      this.task.then((clientSummaries: ClientSummary[]) => {
        this.clientSummaries = clientSummaries;
        this.pagination.rowsNumber = clientSummaries.length;
      });
    },
  },
  created(): void {
    this.load();
    eventBus.$on(ClientAdded.eventName, this.onClientAdded);
    eventBus.$on(EmailCampaignsFetched.eventName, this.load);
    onSubscribedToAccount(this.load);
    onUnsubscribedFromAccount(this.load);
  },
  beforeDestroy(): void {
    eventBus.$off(ClientAdded.eventName, this.onClientAdded);
    eventBus.$off(EmailCampaignsFetched.eventName, this.load);
    offSubscribedToAccount(this.load);
    offUnsubscribedFromAccount(this.load);
  },
  components: {
    RouterLink,
    Tooltip,
  },
});
